import FetchOnceMultiSelect from './FetchOnceMultiSelect';

export default FetchOnceMultiSelect;
